var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13939 1.03907C4.21799 1.03907 1.03907 4.21799 1.03907 8.13939C1.03907 12.0608 4.21799 15.2397 8.13939 15.2397C12.0608 15.2397 15.2397 12.0608 15.2397 8.13939C15.2397 4.21799 12.0608 1.03907 8.13939 1.03907ZM0 8.13939C0 3.64413 3.64413 0 8.13939 0C12.6346 0 16.2788 3.64413 16.2788 8.13939C16.2788 12.6346 12.6346 16.2788 8.13939 16.2788C3.64413 16.2788 0 12.6346 0 8.13939Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13819 12.1211C7.85126 12.1211 7.61865 11.8885 7.61865 11.6016L7.61865 7.44496C7.61865 7.15803 7.85126 6.92543 8.13819 6.92543C8.42512 6.92543 8.65772 7.15803 8.65772 7.44496L8.65772 11.6016C8.65772 11.8885 8.42512 12.1211 8.13819 12.1211Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8328 4.67714C8.8328 5.05974 8.52264 5.36991 8.14003 5.36991C7.75743 5.36991 7.44727 5.05974 7.44727 4.67714C7.44727 4.29454 7.75743 3.98438 8.14003 3.98438C8.52264 3.98438 8.8328 4.29454 8.8328 4.67714Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSmall);
export default __webpack_public_path__ + "static/media/infoSmall.24ef76c92c323a9b71de7419c10ecca3.svg";
export { ForwardRef as ReactComponent };